import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav-side-bar',
  templateUrl: './nav-side-bar.component.html',
  styleUrls: ['./nav-side-bar.component.scss']
})
export class NavSideBarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
